import React from 'react'

import { ColorWheel, Media } from '@syconium/little-miss-figgy'
import { Dialog, PillButton } from '@syconium/little-miss-figgy/dist/components'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'

import ColorGalleryModal from './ColorGalleryModal'
import * as Styles from './styles'

type ColorGalleryModalProps = {
  productHandle: string
  minimize?: boolean | undefined
  ctaVariant?: ColorGalleryCtaVariant
  onSelectColor?: ((colorKey: string) => void) | undefined
}

export type ColorGalleryCtaVariant = 'text' | 'pill'

const ColorGalleryCta = ({
  minimize,
  ctaVariant = 'pill',
  productHandle,
  onSelectColor,
}: ColorGalleryModalProps) => {
  const {
    colorGallery: { colorGalleryCTA, title },
  } = useTranslation()

  const colorGalleryButton =
    ctaVariant === 'pill' ? (
      <PillButton allCaps={false}>
        <ColorWheel />
        <Styles.PillText>
          {minimize ? <Media lessThan='lg'>{title}</Media> : colorGalleryCTA}
          {minimize && <Media greaterThanOrEqual='lg'>{colorGalleryCTA}</Media>}
        </Styles.PillText>
      </PillButton>
    ) : (
      <Styles.ExperimentalColorGalleryButton>{title}</Styles.ExperimentalColorGalleryButton>
    )

  return (
    <Dialog.Provider>
      <Dialog.Disclosure render={colorGalleryButton} />
      <ColorGalleryModal productHandle={productHandle} onSelectColor={onSelectColor} />
    </Dialog.Provider>
  )
}

export default ColorGalleryCta
